var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/Menu/Off",
    clipPath: "url(#clip0_899_5664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.867 1.61205L17.515 0.155046C16.936 -0.0415861 16.3103 -0.0538144 15.724 0.120046L8.538 2.09205L4.155 0.233046C3.69923 0.0429164 3.20356 -0.0317576 2.712 0.0156508C2.22044 0.0630593 1.74819 0.231084 1.33715 0.504812C0.926109 0.778541 0.589002 1.14951 0.355743 1.58479C0.122484 2.02007 0.000287993 2.5062 0 3.00005L0 21.754L7.982 24.035L16.003 22.035L24.003 23.983V4.48305C24.0026 3.83854 23.7946 3.2113 23.4099 2.69421C23.0252 2.17711 22.4842 1.79766 21.867 1.61205ZM15 2.38405V20.219L9 21.719V3.97205L15 2.38405ZM2 3.00005C2.00034 2.83537 2.04135 2.67334 2.11937 2.52832C2.19739 2.38331 2.31001 2.25981 2.44724 2.16878C2.58447 2.07776 2.74205 2.02203 2.90599 2.00655C3.06993 1.99107 3.23516 2.01632 3.387 2.08005L7 3.58105V21.674L2 20.246V3.00005ZM22 21.43L17 20.212V2.09205L21.275 3.52205C21.4838 3.58177 21.6675 3.70785 21.7983 3.88123C21.9291 4.05461 21.9999 4.26586 22 4.48305V21.43Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_5664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMap);
export default __webpack_public_path__ + "static/media/ic_map.0f06a618560866c6ef6d795374128bc3.svg";
export { ForwardRef as ReactComponent };